module.exports = __webpack_public_path__ + "img/jizhang.3c9a4528.jpg";